import { setGlobalCSSVariables } from 'helpers/styleHelpers';

import React, { useEffect } from 'react';

import { classNames } from '@thinkific/chalk/utils';

import { useCommunityContext } from 'components/CommunityContext';
import { EventPreviewProvider } from 'components/Contexts/EventPreview/EventPreviewContext';
import { Sidebar, SidebarType } from 'components/new/layout/Sidebar/Sidebar';
import { SpacesProvider } from 'components/new/providers/SpacesProvider/SpacesProvider';

import * as css from './AppContent.css';

export const CommunityApp = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { community } = useCommunityContext();

  useEffect(() => {
    setGlobalCSSVariables(community.primaryColor);
  }, [community]);

  return (
    <main className={classNames(css.mainApp, className)}>
      <EventPreviewProvider>
        <SpacesProvider communityId={community.id}>
          <Sidebar type={SidebarType.COMMUNITY} />
          <div className={css.content}>{children}</div>
        </SpacesProvider>
      </EventPreviewProvider>
    </main>
  );
};

export default CommunityApp;
